
import { Preferences } from "@capacitor/preferences";
import { EncryptedKey } from "../types";


export interface SecureStorageConfigParams {
  prefix?: string;
  storage: Storage;
}

/**
 * Facade for `CapacitorStorage` encapsulating the access to the actual
 * storage
 */

export class CapacitorStorageFacade {

    private storage: Storage | null;
    private prefix: string;

    constructor() {
        this.storage = null;
        this.prefix = "ebioro-secure-storage";
    }

    public configure(params: SecureStorageConfigParams) {
        Object.assign(this, params);
    }

    public hasKey= async (id: string)=> {

        let result = await this.get(`${this.prefix}:${id}`)

        return result ? result : null;
    }

    public getKey= async(id: string)=> {
        
        const item = await this.get(`${this.prefix}:${id}`)

        return item ? JSON.parse(item) : null;
    }

    public setKey =async(id: string, key: EncryptedKey) => {
        
        return await this.set(`${this.prefix}:${id}`, JSON.stringify({ ...key }))
        
    }

    public removeKey= async (id: string) => {

        return this.remove (`${this.prefix}:${id}`)
        
    }

    public getAllKeys = async ()=> {

        const regexp = RegExp(`^${this.prefix}\\:(.*)`);
        const keys: EncryptedKey[] = [];

        let allKeys = await this.getKeys()
    
        for (let i = 0; i < allKeys.keys.length; i++) {
            const raw_id = allKeys.keys[i];
            if (raw_id !== null && regexp.test(raw_id)) {
              const key = await this.getKey(regexp.exec(raw_id)![1]);
              if (key !== null) {
                keys.push(key);
              }
            }
          }
        
        return keys;
    }

     async get (key: string):Promise<string|null>{

        const v = await Preferences.get({ key });
        if (v) {
          return v.value;
        }
        return null;

     }

    async set(key: string, value: string){
    return Preferences.set({ key, value: value });
    }

    async remove(key: string){

    return Preferences.remove({ key });

    }

    async getKeys(){
    return Preferences.keys();
    }

    async clear(){
    return Preferences.clear();  
    }

    

}